import { useState } from "react"
import { makeStyles } from "tss-react/mui"
import { Box, Grid } from "@mui/material"
import { useFormikContext } from "formik"
import { Agreement, WellknownAgreementType } from "../../../settings/posAcquirer/SupplierAdminPOSTypes"
import { CreateUpdateMerchantFormValues, BankAccountDetails } from "../supplierMerchantsTypes"
import { CreditCardPaymentsDialog } from "./CreditCardPaymentsDialog"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import {
    FetchBankAccountsResponse,
    fetchBankAccountsResult,
    POSQuery,
} from "../../../settings/posAcquirer/SupplierAdminPOSApi"
import { useCurrentSupplier } from "../../../../../suppliers/supplierHooks"
import { CreditCardContentBasedOnStatusAndDetails } from "./CreditCardContentBasedOnStatusAndDetails"

type CreditCardPaymentsProps = Readonly<{
    paymentList: Agreement[]
    bankAccountDetails?: BankAccountDetails
}>

const useStyles = makeStyles()(() => ({
    content: {
        gap: "2rem",
    },
    boxTitleWrap: {
        display: "flex",
        alignItems: "center",
        gap: "1.25rem",
    },
}))

const selectBankAccounts = (data: FetchBankAccountsResponse) => data?.bankAccounts || []

export function CreditCardPayments({ paymentList, bankAccountDetails }: CreditCardPaymentsProps) {
    const { supplierId } = useCurrentSupplier()
    const { classes } = useStyles()
    const { values, setFieldValue } = useFormikContext<CreateUpdateMerchantFormValues>()
    const [dialogState, setDialogState] = useState<boolean>(false)

    const [bankAccountDetailsState, setBankAccountDetailsState] = useState<BankAccountDetails>(bankAccountDetails ?? {})

    const filteredArray = paymentList.filter(
        (agreement: Agreement) => agreement.type === WellknownAgreementType.ADYEN_POS,
    )

    const bankAccountsResult = useApiQuery(fetchBankAccountsResult, {
        queryName: POSQuery.BANK_ACCOUNT_CODES_DETAILS,
        dependencies: {
            supplierId,
        },
        select: selectBankAccounts,
    })

    const isBankAccount = !!bankAccountsResult.data?.length

    return (
        <>
            <Grid container direction="column" wrap="nowrap" className={classes.content}>
                <Box className={classes.boxTitleWrap}>
                    <Grid container flexDirection="column" alignItems="start" gap={3}>
                        <CreditCardContentBasedOnStatusAndDetails
                            status={filteredArray[0]?.adyenAgreement?.status}
                            acquiringDetails={values.acquiringDetails}
                            bankAccountDetails={bankAccountDetailsState}
                            isBankAccount={isBankAccount}
                            handleClick={() => setDialogState(true)}
                        />
                    </Grid>
                </Box>
            </Grid>
            {dialogState && (
                <CreditCardPaymentsDialog
                    dialogState={dialogState}
                    setDialogState={setDialogState}
                    isBankAccount={isBankAccount}
                    initialValues={values.acquiringDetails?.acquiring}
                    isPaymentSetup={!!bankAccountDetails}
                    handleSavePayment={(data) => {
                        const { bankAccountInfo, ...restValues } = data
                        const acquiringDetails = {
                            ...restValues,
                        }
                        setFieldValue("acquiringDetails.acquiring", acquiringDetails)
                        bankAccountInfo &&
                            setBankAccountDetailsState((prev) => {
                                return { ...prev, ...bankAccountInfo }
                            })
                    }}
                />
            )}
        </>
    )
}
